<template>
  <div>
    <div class="workPoolItem" v-if="companyValidate">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="企业申请" name="pushList"></el-tab-pane>
        <el-tab-pane label="申请历史" name="pushHistory"></el-tab-pane>
      </el-tabs>
      <!--切换-->
      <!--申请管理-->
      <div>
        <!-- 企业申请 -->
        <div class="companyList" v-show="activeName == 'pushList'">
          <transition name="loadShadow">
            <div class="loadShadow" v-show="shadowShow">
              <i class="loadgif"></i>
            </div>
          </transition>
          <table class="formLoop">
            <thead>
              <tr>
                <th style="width: 8%">企业名称</th>
                <th style="width: 8%">营业执照</th>
                <th style="width: 5%">联系人</th>
                <th style="width: 5%">联系电话</th>
                <th style="width: 6%">邮箱</th>
                <th style="width: 6%">申请时间</th>
                <th style="width: 12%">操作</th>
              </tr>
            </thead>
            <tbody v-if="applyList.length > 0">
              <tr v-for="(item,index) in applyList" :key="index">
                <td>
                  <span
                    style="font-weight:bold;color:#5b9bd1;cursor:pointer"
                    class="user-name"
                  >{{item.entname}}</span>
                </td>

                <td>
                  <span style="font-weight:bold">{{item.certid}}</span>
                </td>
                <td style="font-weight:bold">{{item.conname}}</td>
                <td>
                  <span style="font-weight:bold">{{item.contel}}</span>
                </td>
                <td style="font-weight:bold">{{item.entemail}}</td>
                <td>
                  <span>{{item.senddate | formatDate('.')}}</span>
                </td>
                <td>
                  <el-button type="success" @click="openDialog(item)">通过</el-button>

                  <el-button type="danger" @click="refuse(item)">拒绝</el-button>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="talentsNum > 0">
            <el-pagination
              :page-size="countnum"
              :pager-count="5"
              layout="prev, pager, next"
              :total="talentsNum"
              @current-change="searchApply"
              @prev-click="searchApply"
              @next-click="searchApply"
            ></el-pagination>
          </div>
        </div>
        <el-dialog
          title="选择人员"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose"
          :destroy-on-close="true"
        >
          <div>
            <el-select v-model="selectedSubordinate" placeholder="选择人员" @change="selectSubordinate">
              <el-option
                v-for="(item, index) in subordinateList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleCancel">取 消</el-button>
            <el-button type="primary" @click="dialogVisibleConfirm">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 申请历史 -->
        <div class="companyList" v-show="activeName == 'pushHistory'">
          <transition name="loadShadow">
            <div class="loadShadow" v-show="shadowShow">
              <i class="loadgif"></i>
            </div>
          </transition>
          <table class="formLoop">
            <thead>
              <tr>
                <th style="width: 8%">企业名称</th>
                <th style="width: 8%">营业执照</th>
                <th style="width: 5%">联系人</th>
                <th style="width: 5%">联系电话</th>
                <th style="width: 6%">邮箱</th>
                <th style="width: 6%">申请时间</th>
                <th style="width: 12%">状态</th>
              </tr>
            </thead>
            <tbody v-if="applyEndList.length > 0">
              <tr v-for="(item,index) in applyEndList" :key="index">
                <td>
                  <span
                    style="font-weight:bold;color:#5b9bd1;cursor:pointer"
                    class="user-name"
                    @click="checkCompany(item.entid)"
                  >{{item.entname}}</span>
                </td>

                <td>
                  <span style="font-weight:bold">{{item.certid}}</span>
                </td>
                <td style="font-weight:bold">{{item.conname}}</td>
                <td>
                  <span style="font-weight:bold">{{item.contel}}</span>
                </td>
                <td style="font-weight:bold">{{item.entemail}}</td>
                <td>
                  <!-- 申请时间 -->
                  <span>{{item.senddate | formatDate('.')}}</span>
                </td>
                <td>
                  <span v-if="item.StrHasChk == 1">已通过</span>
                  <span v-if="item.StrHasChk == 2">已拒绝</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="EndtalentsNum > 0">
            <el-pagination
              :page-size="countnum"
              :pager-count="5"
              layout="prev, pager, next"
              :total="EndtalentsNum"
              @current-change="searchApply"
              @prev-click="searchApply"
              @next-click="searchApply"
            ></el-pagination>
          </div>
        </div>

        <!--查看企业-->
        <el-dialog title="企业信息" :visible.sync="dialogFormVisible" center>
          <el-form :model="form" label-width="80px">
            <el-form-item label="企业名称">
              <el-input v-model="form.entName" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="信用代码">
              <el-input v-model="form.entCertId" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="企业地址">
              <el-input
                v-model="nationName"
                autocomplete="off"
                :disabled="true"
                style="width:200px"
              ></el-input>/
              <el-input
                v-model="form.entAdd"
                autocomplete="off"
                :disabled="true"
                style="width:200px"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业性质">
              <el-input v-model="form.entClass" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="企业规模">
              <el-input v-model="form.entScale" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="企业产业">
              <el-input v-model="form.entIndustry" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="联系人">
              <el-input v-model="form.entConName" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="form.entConTel" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="简历邮箱">
              <el-input v-model="form.entEmail" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="企业介绍">
              <el-input
                type="textarea"
                v-model="form.entSummary"
                autocomplete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import xz from "../common";
// import brokerForm from "../components/form/brokerForm";
// import TeamTreeStructure from "../components/widgets/teamMemberTree";
export default {
  components: {
    // TeamTreeStructure
    // brokerForm,
  },
  data: function () {
    return {
      nationName: "", // 地区名称
      checkCompanyId: "", // 查看企业的企业id值
      dialogFormVisible: false, // 查看企业信息
      form: {},
      //下级人员列表
      subordinateList: [],
      //已选择的下级
      selectedSubordinate: null,
      dialogVisible: false,
      activeName: "pushList",
      shadowShow: false,// 打开遮罩
      talentsNum: 0,
      EndtalentsNum: 0,
      countnum: 10,
      currentPage: 1,
      applyList: [
        // {
        //   entname: "测试",
        //   certid: "d2we61f6w1",
        //   conname: "测试",
        //   contel: "18667868316",
        //   entemail: "598595404@qq.com",
        //   senddate: "2020-07-10"
        // }
      ], // 企业申请
      applyEndList: [], // 申请历史
      companyValidate: true,
      // 选中的人员id值
      userId: "",
      // 企业id值
      CompanyitemId: {},
    };
  },
  created() {
    this.applyLists();
    this.entApplyLists();
    //获取下级人员列表
    xz.groupMember(Cookies.get("userid-b")).then((member) => {
      if (member && Array.isArray(member)) {
        member.forEach((m) => {
          this.subordinateList.push({
            value: m.id,
            label: m.userName,
            mobile: m.usermobile,
          });
        });
      } else {
        this.subordinateList = [];
      }
    });
    // 企业审核账号权限
    if (Cookies.get("userid-b")) {
      this.companyValidate = true;
    }
  },
  computed: {
    //权限
    purviews() {
      return this.$store.state.purview;
    },
  },
  watch: {},
  methods: {
    checkCompany(id) {
      // this.dialogFormVisible = true;
      this.checkCompanyId = id;
      this.checkCompanyMessage();
    },
    checkCompanyMessage() {
      xz.getCompanyInformation(this.checkCompanyId).then((res) => {
        if (res == false) {
          this.$message.error("未找到该企业信息，请重试");
        } else {
          let nation = res.entNation;
          let nationOjb = this.$store.getters.codeToggleObj(nation);
          let nationName = this.$store.getters.localName(nationOjb);
          // // console.log('nationname',nationName)
          this.nationName = nationName;
          // this.form.entAdd = nationName + res.entAdd
          // console.log(res);
          this.form = res;
          this.dialogFormVisible = true;
        }
      });
    },
    // 下拉选择人员
    selectSubordinate(d) {
      this.userId = d;
      // console.log("d", d);
      this.selectedSubordinate = d;
    },
    // 弹出框->确定按钮 通过企业审核
    dialogVisibleConfirm() {
      // console.log("ok");
      let initData = {
        entApprove: "1",
        userid: this.userId,
      };
      let CompanyId = this.CompanyitemId;
      let datas = JSON.stringify(initData);
      xz.validateCompany(CompanyId, datas);
      this.dialogVisible = false;
      this.$message({
        message: "该企业已通过",
        type: "success",
      });
      this.applyLists();
    },
    // 弹出框->取消按钮
    dialogVisibleCancel() {
      this.dialogVisible = false;
    },
    // 打开人员选择框
    openDialog(item) {
      this.dialogVisible = true;
      // console.log("item id", item);
      // console.log("item ids", item.entid);
      this.CompanyitemId = item.entid;
      // console.log("gongsi id", this.CompanyitemId);
    },
    entApplyLists() {
      // 企业申请历史
      xz.entApplyList(1, "", 10).then((msg) => {
        // console.log("msg", msg);
        if (msg) {
          this.EndtalentsNum = msg.totalnum;
          this.applyEndList = msg.list;
        }
      });
    },
    // 获取所有待审核的企业列表applyList
    applyLists() {
      // status为0
      xz.entApplyList(1, 0, 10).then((msg) => {
        if (msg) {
          this.talentsNum = msg.totalnum;
          this.applyList = msg.list;
          this.shadowShow = false; // 关闭加载
        }
      });
    },
    searchApply() {},
    // 拒绝企业
    refuse(item) {
      let initData = {
        entApprove: "2",
        userid: this.userId,
      };
      let CompanyId = item.entid;
      let datas = JSON.stringify(initData);
      xz.validateCompany(CompanyId, datas);
      this.dialogVisible = false;
      this.$message({
        message: "该企业已拒绝",
        type: "warning",
      });
      this.entApplyLists();
    },
  },
};
</script>
<style scoped>
.el-dialog {
  border-radius: 6px;
}

.btn-def {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  background-color: #fff;
}

.btn-def:hover {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  background-color: #fff;
}

.btn-sub {
  border: 1px solid #32c5d2;
  border-radius: 4px;
  color: #32c5d2;
  background-color: #fff;
}

.btn-sub:hover {
  border-color: #32c5d2;
  color: #fff;
  background-color: #32c5d2;
}

.el-button a {
  color: #606266;
}

.search-item {
  position: relative;
}

.search-item .closeBtn {
  position: absolute;
  right: 20px;
  top: 14px;
  font-size: 24px;
  cursor: pointer;
}

.search-item .closeBtn:hover {
  color: #409eff;
}

.search-item .el-form-item {
  display: inline-block;
  width: 30%;
  margin: 10px;
}

.search-item .search-input {
  width: 75%;
}

.filterApply {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.selecteArea {
  margin-left: 25px;
}
</style>